// Generated from branding/version-4 by scripts/generate-brand.mjs.
export const LOGO_SETTINGS = {
  "version": 4,
  "baselineRadius": 256,
  "strokeWidth": 18,
  "gearCount": 12,
  "tipWidth": 0.3,
  "baseWidth": 0.128,
  "amplitude": 0.1,
  "innerRadius": 0.311,
  "gapDepth": 0.418,
  "toothPeriod": 1.4,
  "rotationPeriod": 8,
  "rotations": 1,
  "entrance": 0.6,
  "exit": 0.6,
  "scalePercent": 6
} as const

export const LOGO_GEOMETRY = {
  "stroke": 18,
  "rootRadius": 139.99200000000002,
  "rootCorner": 14.4,
  "direction": [
    0.9787041774379394,
    0.20527574884902128
  ],
  "normal": [
    -0.20527574884902128,
    0.9787041774379394
  ],
  "offset": -12.504386091884587,
  "sideDistance": 154.38036245556418,
  "sideLower": [
    153.65955286855277,
    19.452449606224953
  ],
  "rootLower": [
    136.64759743549587,
    30.41700476882409
  ],
  "centerlineRadius": 247,
  "tipCorner": 21.76,
  "wideBaseJoin": false,
  "sectorHalf": 0.2617993877991494,
  "tangentAngle": 0.21902368467629965,
  "caps": [
    {
      "axis": [
        1,
        0
      ],
      "inwardLower": [
        -0.9787041774379394,
        -0.20527574884902128
      ],
      "outwardUpper": [
        0.9787041774379394,
        -0.20527574884902128
      ],
      "sideUpper": [
        665.6595528685527,
        492.54755039377505
      ],
      "sideLower": [
        665.6595528685527,
        531.452449606225
      ],
      "rootUpper": [
        648.6475974354959,
        481.5829952311759
      ],
      "rootLower": [
        648.6475974354959,
        542.4170047688241
      ]
    },
    {
      "axis": [
        0.8660254037844387,
        0.49999999999999994
      ],
      "inwardLower": [
        -0.7449448060266978,
        -0.6671261020030963
      ],
      "outwardUpper": [
        0.9502205548757191,
        0.31157807543484295
      ],
      "sideUpper": [
        654.7993011214372,
        571.9834609094489
      ],
      "sideLower": [
        635.3468515152123,
        605.6760919591038
      ],
      "rootUpper": [
        645.5487931296607,
        553.9818998809138
      ],
      "rootLower": [
        615.1317883608367,
        606.6656975545819
      ]
    },
    {
      "axis": [
        0.5000000000000001,
        0.8660254037844386
      ],
      "inwardLower": [
        -0.31157807543484317,
        -0.950220554875719
      ],
      "outwardUpper": [
        0.6671261020030964,
        0.7449448060266977
      ],
      "sideUpper": [
        605.6760919591038,
        635.3468515152122
      ],
      "sideLower": [
        571.9834609094489,
        654.7993011214371
      ],
      "rootUpper": [
        606.665697554582,
        615.1317883608366
      ],
      "rootLower": [
        553.9818998809139,
        645.5487931296608
      ]
    },
    {
      "axis": [
        6.123233995736766e-17,
        1
      ],
      "inwardLower": [
        0.20527574884902122,
        -0.9787041774379394
      ],
      "outwardUpper": [
        0.20527574884902133,
        0.9787041774379394
      ],
      "sideUpper": [
        531.452449606225,
        665.6595528685527
      ],
      "sideLower": [
        492.54755039377505,
        665.6595528685527
      ],
      "rootUpper": [
        542.4170047688241,
        648.6475974354959
      ],
      "rootLower": [
        481.5829952311759,
        648.6475974354959
      ]
    },
    {
      "axis": [
        -0.4999999999999998,
        0.8660254037844387
      ],
      "inwardLower": [
        0.6671261020030961,
        -0.7449448060266979
      ],
      "outwardUpper": [
        -0.3115780754348428,
        0.950220554875719
      ],
      "sideUpper": [
        452.016539090551,
        654.7993011214372
      ],
      "sideLower": [
        418.32390804089624,
        635.3468515152123
      ],
      "rootUpper": [
        470.0181001190862,
        645.5487931296607
      ],
      "rootLower": [
        417.334302445418,
        615.1317883608367
      ]
    },
    {
      "axis": [
        -0.8660254037844387,
        0.49999999999999994
      ],
      "inwardLower": [
        0.9502205548757191,
        -0.31157807543484295
      ],
      "outwardUpper": [
        -0.7449448060266978,
        0.6671261020030963
      ],
      "sideUpper": [
        388.6531484847877,
        605.6760919591038
      ],
      "sideLower": [
        369.2006988785628,
        571.9834609094489
      ],
      "rootUpper": [
        408.8682116391633,
        606.6656975545819
      ],
      "rootLower": [
        378.4512068703392,
        553.9818998809138
      ]
    },
    {
      "axis": [
        -1,
        1.2246467991473532e-16
      ],
      "inwardLower": [
        0.9787041774379394,
        0.20527574884902117
      ],
      "outwardUpper": [
        -0.9787041774379394,
        0.2052757488490214
      ],
      "sideUpper": [
        358.34044713144726,
        531.452449606225
      ],
      "sideLower": [
        358.34044713144726,
        492.54755039377505
      ],
      "rootUpper": [
        375.35240256450413,
        542.4170047688241
      ],
      "rootLower": [
        375.35240256450413,
        481.5829952311759
      ]
    },
    {
      "axis": [
        -0.8660254037844388,
        -0.4999999999999997
      ],
      "inwardLower": [
        0.7449448060266979,
        0.6671261020030961
      ],
      "outwardUpper": [
        -0.950220554875719,
        -0.3115780754348427
      ],
      "sideUpper": [
        369.2006988785628,
        452.016539090551
      ],
      "sideLower": [
        388.6531484847877,
        418.32390804089624
      ],
      "rootUpper": [
        378.4512068703392,
        470.0181001190862
      ],
      "rootLower": [
        408.8682116391633,
        417.334302445418
      ]
    },
    {
      "axis": [
        -0.5000000000000004,
        -0.8660254037844385
      ],
      "inwardLower": [
        0.3115780754348435,
        0.950220554875719
      ],
      "outwardUpper": [
        -0.6671261020030967,
        -0.7449448060266974
      ],
      "sideUpper": [
        418.32390804089613,
        388.6531484847878
      ],
      "sideLower": [
        452.0165390905509,
        369.20069887856283
      ],
      "rootUpper": [
        417.33430244541796,
        408.86821163916335
      ],
      "rootLower": [
        470.01810011908606,
        378.45120687033926
      ]
    },
    {
      "axis": [
        -1.8369701987210297e-16,
        -1
      ],
      "inwardLower": [
        -0.2052757488490211,
        0.9787041774379394
      ],
      "outwardUpper": [
        -0.20527574884902144,
        -0.9787041774379394
      ],
      "sideUpper": [
        492.54755039377505,
        358.34044713144726
      ],
      "sideLower": [
        531.452449606225,
        358.34044713144726
      ],
      "rootUpper": [
        481.5829952311759,
        375.35240256450413
      ],
      "rootLower": [
        542.4170047688241,
        375.35240256450413
      ]
    },
    {
      "axis": [
        0.5000000000000001,
        -0.8660254037844386
      ],
      "inwardLower": [
        -0.6671261020030964,
        0.7449448060266977
      ],
      "outwardUpper": [
        0.31157807543484317,
        -0.950220554875719
      ],
      "sideUpper": [
        571.9834609094489,
        369.20069887856283
      ],
      "sideLower": [
        605.6760919591038,
        388.6531484847878
      ],
      "rootUpper": [
        553.9818998809139,
        378.45120687033926
      ],
      "rootLower": [
        606.665697554582,
        408.86821163916335
      ]
    },
    {
      "axis": [
        0.8660254037844384,
        -0.5000000000000004
      ],
      "inwardLower": [
        -0.9502205548757189,
        0.3115780754348435
      ],
      "outwardUpper": [
        0.7449448060266973,
        -0.6671261020030967
      ],
      "sideUpper": [
        635.3468515152122,
        418.32390804089613
      ],
      "sideLower": [
        654.7993011214371,
        452.0165390905509
      ],
      "rootUpper": [
        615.1317883608366,
        417.33430244541796
      ],
      "rootLower": [
        645.5487931296608,
        470.01810011908606
      ]
    }
  ],
  "gapRadius": 139.99200000000002
} as const
